import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const CrossSellingListItem = x => x;
const CrossSellingList = x => x;
const CalculatedCrossSellingList = x => x;
const newtypeCrossSellingList_ = {Coercible0: () => {}};
const newtypeCrossSellingListIt = {Coercible0: () => {}};
const newtypeCalculatedCrossSel = {Coercible0: () => {}};
const hasFieldCrossSellingListI = dictHasField => dictHasField;
const hasFieldCrossSellingList = dictHasField => dictHasField;
const hasFieldCalculatedCrossSe = dictHasField => dictHasField;
const eqCrossSellingListItem = {eq: x => y => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqCartProductKey.eq(x.content)(y.content)};
const eqCrossSellingList = {eq: x => y => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqCrossSellingListItem).eq(x.items)(y.items) && x.name === y.name};
const eqCalculatedCrossSellingL = {
  eq: x => y => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dItemId.eqItemId)({eq: Data$dEq.eqArrayImpl(Restaumatic$dMenu$dV2$dTypes$dItemId.eqItemId.eq)}).eq(x.items)(y.items)
};
const genericCrossSellingListItem = {to: x => x, from: x => x};
const showCrossSellingListItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["content", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showCartProductKey.show(v.content)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "CrossSellingListItem"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCrossSellingListItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "content"})(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeCartProductKey)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCrossSellingList = {to: x => x, from: x => x};
const showCrossSellingList = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showCrossSellingListItem);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0.show(v.items)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "name",
              Data$dShow.showStringImpl(v.name)
            ]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CrossSellingList"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCrossSellingList = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeCrossSellingListItem)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "name"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCalculatedCrossSellingList = {to: x => x, from: x => x};
const showCalculatedCrossSellingList = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId)({show: Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId.show)});
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0.show(v.items)]))([]);
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CalculatedCrossSellingList"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCalculatedCrossSellingList = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})(Unscramble.decodeMap(Restaumatic$dMenu$dV2$dTypes$dItemId.ufromJSONKeyItemId)(Restaumatic$dMenu$dV2$dTypes$dItemId.ordItemId)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dMenu$dV2$dTypes$dItemId.unscrambleDecodeItemId.unsafeDecode)
    }))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCrossSellingListItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCrossSellingListItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CrossSellingListItem"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "content"})({
      encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartProductKey.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCrossSellingList = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCrossSellingList)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CrossSellingList"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "name"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dMap$dOrdered.encodeMap(Data$dTuple$dT2.encodeT2({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeCrossSellingListItem.encode(v)), Data$dList$dTypes.Nil)}));
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCalculatedCrossSellingList = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCalculatedCrossSellingList)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CalculatedCrossSellingList"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dItemId.asJSONKeyItemId)({
        encode: Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dItemId.encodeItemId.encode)
      })((() => {
        const $0 = Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dTypes$dItemId.encodeItemId.encode);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCrossSellingListItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCrossSellingListItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CrossSellingListItem"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "content"
  })({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeCartProductKey.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCrossSellingList = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCrossSellingList)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CrossSellingList"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "name"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "items"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeCrossSellingListItem.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(Data$dOrd.ordString);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCalculatedCrossSellingList = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCalculatedCrossSellingList)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CalculatedCrossSellingList"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "items"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Restaumatic$dMenu$dV2$dTypes$dItemId.ordItemId)(Restaumatic$dMenu$dV2$dTypes$dItemId.asJSONKeyItemId)(Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dMenu$dV2$dTypes$dItemId.decodeItemId))((() => {
      const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dMenu$dV2$dTypes$dItemId.decodeItemId);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CalculatedCrossSellingList,
  CrossSellingList,
  CrossSellingListItem,
  decodeCalculatedCrossSellingList,
  decodeCrossSellingList,
  decodeCrossSellingListItem,
  encodeCalculatedCrossSellingList,
  encodeCrossSellingList,
  encodeCrossSellingListItem,
  eqCalculatedCrossSellingL,
  eqCrossSellingList,
  eqCrossSellingListItem,
  genericCalculatedCrossSellingList,
  genericCrossSellingList,
  genericCrossSellingListItem,
  hasFieldCalculatedCrossSe,
  hasFieldCrossSellingList,
  hasFieldCrossSellingListI,
  newtypeCalculatedCrossSel,
  newtypeCrossSellingListIt,
  newtypeCrossSellingList_,
  showCalculatedCrossSellingList,
  showCrossSellingList,
  showCrossSellingListItem,
  unscrambleDecodeCalculatedCrossSellingList,
  unscrambleDecodeCrossSellingList,
  unscrambleDecodeCrossSellingListItem
};
